<template>
  <div>
    <el-card shadow="always" style="width: 1300px; margin: 20px auto; border-radius: 12px; border: none;">
      <div style="margin: 10px 0 60px 0">
        <!--搜索栏，页面大小调整栏-->
        <el-col :span="8">
          <el-input
            v-model="userInput"
            @input="inputContent"
            style="width: 500px"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </el-col>
        <div style="width: 15%; float: right">
          <!-- 调整页面大小 -->
          Show
          <el-dropdown @command="changeValue">
            <el-button type="info" size="small">
              <span>{{ queryInfo.pagesize }}</span
              ><i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in option"
                :key="item.value"
                :command="item.label"
                ><span> {{ item.label }}</span></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          entries
        </div>
      </div>
      <div>
        <el-table
          :data="list"
          id="educe-table"
          style="width: 1250px"
          highlight-current-row
          justify="center"
          stripe
          @sort-change="sortChange"
          border
        >
          <el-table-column
            prop="organismName"
            label="Organism"
            width="450"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="assembly"
            label="Assembly"
            width="300"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="geneName"
            label="Genes"
            width="200"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="length"
            label="Sequence Length (bp)"
            width="300"
            sortable="custom"
            ><template slot-scope="scope">
              <el-popover placement="right" width="400" trigger="click">
                <el-table :data="[scope.row]">
                  <el-table-column
                    width="400"
                    property="sequence"
                    label="Gene Senquence"
                  ></el-table-column>
                </el-table>
                <el-button slot="reference">{{
                  formatSize(scope.row.length)
                }}</el-button>
              </el-popover>
            </template></el-table-column
          >
        </el-table>
      </div>
      <div style="display: flex">
        <div
          class="block"
          style="margin-top: 20px; width: 600px; display: inline-block"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="queryInfo.pagesize"
            layout="prev, pager, next, jumper"
            :total="total"
            :current-page.sync="queryInfo.pagenum"
          >
          </el-pagination>
        </div>
        <span style="margin-top: 20px; margin-right: 200px; width: 500px"
          >Showing {{ total == 0 ? 0 : (queryInfo.pagenum - 1) * 10 + 1 }} to
          {{
            queryInfo.pagenum * queryInfo.pagesize > total
              ? total
              : queryInfo.pagenum * queryInfo.pagesize
          }}
          of {{ total }} entries</span
        >
        <div style="margin: 10px; float: right">
          <el-button type="primary" @click="tableDOWNLOAD">Table download</el-button>
        </div>
        <div style="margin: 10px; float: right">
          <el-button type="success" @click="fastaDOWNLOAD">Fasta download</el-button>
        </div>
      </div>
    </el-card>
    </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "TreeResult",
  components: {  },
  data() {
    return {
      value1: "",
      value2: "",
      genomesTreeList: [],
      genesTreeList: [],
      userInput: "",
      queryInfo: {
        pagenum: 1, //当前页面
        pagesize: 10, //页面大小
      },
      list: [],
      total: 0,
      option: [
        //页面大小
        { label: 10, value: 0 },
        { label: 25, value: 1 },
        { label: 50, value: 2 },
        { label: 100, value: 3 },
      ],
      sort: "",
      method: "",
      list_fields: {
        assembly: "assembly",
        protein: "protein",
        geneID: "geneID",
        definition: "definition",
        genesGroup: "genesGroup",
        length: "length",
        location: "location",
        locus: "locus",
        lowerQuartile: "lowerQuartile",
        upperQuartile: "upperQuartile",
        median: "median",
        organismName: "organismName",
        proteinSequence: "proteinSequence",
        sequence: "sequence",
      },
      title: "Genes_Infor_Result",
    };
  },
  created() {
    this.loadInfo();
  },

  methods: {
    async loadInfo() {
      // 从 sessionStorage 读取对象
      var that = this;
      this.value1 = sessionStorage.getItem("value1");
      this.value2 = sessionStorage.getItem("value2");
      console.log(this.value1);
      console.log(this.value2);
      const { data: res } = await this.$axios.get(
        "/api/api.tree/result",
        {
          params: {
            genomesTreeList: this.value1,
            genesTreeList: this.value2,
            page: 1,
            pageSize: this.queryInfo.pagesize,
            search: this.userInput,
            sort: this.sort,
            method: this.sortMethod,
          },
          paramsSerializer: function (params) {
            return that.$qs.stringify(params, { arrayFormat: "repeat" });
          },
        },
      );
      this.genomesTreeList = this.value1;
      this.genesTreeList = this.value2;


      if (res.code == 1) {
        this.list = res.data.rows;
        this.total = res.data.count;
      } else {
        this.list = [];
        this.total = 0;
      }
    },
    async changeValue(e) {
      //改变页面大小
      this.queryInfo.pagesize = e;
      this.handleCurrentChange(1);
    },
    async handleCurrentChange(val) {
      var that = this;
      //底部分页按钮
      const { data: res } = await this.$axios.get("/api/api.tree/result", {
        params: {
          genomesTreeList: this.genomesTreeList,
          genesTreeList: this.genesTreeList,
          page: val,
          pageSize: this.queryInfo.pagesize,
          search: this.userInput,
          sort: this.sort,
          method: this.sortMethod,
        },
        paramsSerializer: function (params) {
          return that.$qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      // 赋值
      this.queryInfo.pagenum = val;
      this.list = res.data.rows;
    },
    viewDetail(row) {
      sessionStorage.setItem("assenbly", row.assembly);
      this.$router.push({ path: "/GeneName" });
    },
    async inputContent(e) {
      this.userInput = e;
      // 调用获取信息的api请求 , 并解构出data, 重命名为res
      var that = this;
      //底部分页按钮
      const { data: res } = await this.$axios.get("/api/api.tree/result", {
        params: {
          genomesTreeList: this.genomesTreeList,
          genesTreeList: this.genesTreeList,
          page: 1,
          pageSize: this.queryInfo.pagesize,
          search: this.userInput,
          sort: this.sort,
          method: this.sortMethod,
        },
        paramsSerializer: function (params) {
          return that.$qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      // 赋值
      this.queryInfo.pagenum = 1;
      this.total = res.data.count;
      this.list = res.data.rows;
    },
    async sortChange(object) {
      this.sort = object.prop;
      if (object.order == "descending") {
        this.sortMethod = "DESC";
      } else if (object.order == "ascending") {
        this.sortMethod = "ASC";
      }

      // 调用获取信息的api请求 , 并解构出data, 重命名为res
      var that = this;
      //底部分页按钮
      const { data: res } = await this.$axios.get("/api/api.tree/result", {
        params: {
          genomesTreeList: this.genomesTreeList,
          genesTreeList: this.genesTreeList,
          page: 1,
          pageSize: this.queryInfo.pagesize,
          search: this.userInput,
          sort: this.sort,
          method: this.sortMethod,
        },
        paramsSerializer: function (params) {
          return that.$qs.stringify(params, { arrayFormat: "repeat" });
        },
      });

      // 赋值
      this.queryInfo.pagenum = 1;
      this.total = res.data.count;
      this.list = res.data.rows;
    },
    async fastaDOWNLOAD() {
      // 1. Fetch full dataset
      const { data: res } = await this.$axios.get("/api/api.tree/result", {
        params: {
          genomesTreeList: this.genomesTreeList,
          genesTreeList: this.genesTreeList,
          page: 1,
          pageSize: this.total > 0 ? this.total : 1000,
          search: this.userInput,
          sort: this.sort,
          method: this.sortMethod,
        },
        paramsSerializer: (params) => this.$qs.stringify(params, { arrayFormat: "repeat" }),
      });

      if (!res || !res.data || !res.data.rows) return;
      const rows = res.data.rows;

      // 2. Build FASTA string
      let fastaContent = "";
      rows.forEach(row => {
        fastaContent += `>${row.organismName}|${row.assembly}|${row.geneName}\n${row.sequence || ''}\n`;
      });

      // 3. Trigger download
      const blob = new Blob([fastaContent], { type: 'text/plain;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'tree_result.fasta');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    async tableDOWNLOAD() {
      // 1. Fetch full dataset
      const { data: res } = await this.$axios.get("/api/api.tree/result", {
        params: {
          genomesTreeList: this.genomesTreeList,
          genesTreeList: this.genesTreeList,
          page: 1,
          pageSize: this.total > 0 ? this.total : 1000,
          search: this.userInput,
          sort: this.sort,
          method: this.sortMethod,
        },
        paramsSerializer: (params) => this.$qs.stringify(params, { arrayFormat: "repeat" }),
      });

      if (!res || !res.data || !res.data.rows) return;
      const rows = res.data.rows;

      // 2. Build CSV string
      // Adding BOM (\uFEFF) so Excel correctly recognizes UTF-8 encoded characters.
      let csvContent = "\uFEFFOrganism,Assembly,Genes,Sequence Length (bp),Gene Sequence\n";
      rows.forEach(row => {
        const org = `"${(row.organismName || '').replace(/"/g, '""')}"`;
        const assem = `"${(row.assembly || '').replace(/"/g, '""')}"`;
        const gene = `"${(row.geneName || '').replace(/"/g, '""')}"`;
        const len = row.length || 0;
        const seq = `"${(row.sequence || '').replace(/"/g, '""')}"`;
        csvContent += `${org},${assem},${gene},${len},${seq}\n`;
      });

      // 3. Trigger download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'tree_result.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    formatSize(size) {
      return size.toLocaleString(); // 使用 toLocaleString 方法进行格式化
    },
  },
};

</script>

<style scoped></style>